// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { isFrontendDebugEnabled } from "./logging";

// Custom language detector that normalizes to base language
const customLanguageDetector = {
    type: 'languageDetector',
    detect: () => {
        // Try localStorage first
        const stored = localStorage.getItem('i18nextLng');
        if (stored && ['en', 'ge', 'fr'].includes(stored)) {
            return stored;
        }

        // Fallback to browser language, normalized
        const browserLang = navigator.language || navigator.userLanguage || 'en';
        const baseLang = browserLang.split('-')[0].toLowerCase();

        // Map "de" to "ge" for German
        if (baseLang === 'de') return 'ge';
        if (baseLang === 'fr') return 'fr';
        return 'en'; // default
    },
    init: () => {},
    cacheUserLanguage: (lng) => {
        localStorage.setItem('i18nextLng', lng);
    }
};

i18n
    .use(HttpApi) // load translation files
    .use(customLanguageDetector) // detect and normalize browser language
    .use(initReactI18next) // pass to react-i18next
    .init({
        fallbackLng: "en", // default language
        supportedLngs: ["en", "ge", "fr"], // only these languages are supported
        load: "languageOnly", // ignore region codes (e.g., "en-US" -> "en")
        debug: false, // Disable debug to avoid race condition warnings during initial load
        interpolation: {
            escapeValue: false, // react already escapes
        },
        backend: {
            loadPath: "/locales/{{lng}}/translation.json",
        },
        react: {
            useSuspense: false, // don't block rendering while loading translations
        },
        // Preload the detected language to avoid missing key warnings
        preload: ["en", "ge", "fr"],
        initImmediate: false, // Wait for initial load to complete
    });

export default i18n;
